import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { ModalNuevaMarca } from "../../components/empresa_uno_comp/ModalNuevaMarca";
import { Preloader } from "../../components/Preloader";
import Table from "../../components/Table";
import "../../css/empresa_uno/product.css";
import "../../css/table.css";
import buscar_azul from "../../images/search_azul.png";
import { ApiService } from "../../components/ApiService";
import { Button, Box, Typography, CircularProgress } from "@mui/material";
import LupaIcon from "../../svg/lupaIcon";
import TablesMobile from "../../components/empresa/TablesMobile";
import SearchCompany from "./SearchCompany";


const API_url = process.env.REACT_APP_API_URL;

export const Marcas = ({ selectedSucursal, permisos }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);


	useEffect(() => {
		if (permisos?.leer) {
			reloadBrands();
		}
	}, [selectedSucursal]);

	const handleOpenModal = () => setIsModalOpen(true);
	const handleCloseModal = () => setIsModalOpen(false);

	// Columnas de la tabla
	const columns = [
		{
			name: "N°",
			selector: (row, index) => index + 1, // Agrega un contador para los elementos
			sortable: true,
		},
		{
			name: "Foto",
			cell: (row) => (
				<img
					src={`${API_url}${row.image}`} // Ruta completa de la imagen
					alt={row.name}
					style={{ width: "120px", height: "50px", objectFit: "cover" }}
				/>
			),
			sortable: false, // Las imágenes no necesitan ordenarse
		},
		{
			name: "Marca",
			selector: (row) => row.name, // Mostrar el campo "fullName" de la API
			sortable: true,
		},
	];

	// Estado para almacenar los datos de la API
	const [data, setData] = useState([]);
	const [filteredData, setFilteredData] = useState([]); // Datos filtrados para la tabla
	const [search, setSearch] = useState(""); // Término de búsqueda
	const [loading, setLoading] = useState(true);

	const reloadBrands = async () => {
		try {
			setLoading(true);
			const url = `api/company/brand/list?key_branch=${selectedSucursal}`;
			const options = { method: "GET" };

			const response = await ApiService.fetchData(url, options);

			if (!response) {
				throw new Error("Error al recargar las marcas");
			}

			const formattedData = Array.isArray(response) ? response : response.data || [];
			setData(formattedData);
			setFilteredData(formattedData);
		} catch (error) {
			toast.error("No se pudo actualizar la lista de marcas");
		} finally {
			setLoading(false);
		}
	};

	// Efecto para actualizar los datos filtrados con base en el término de búsqueda
	useEffect(() => {
		if (search.length > 1) {
			const filtered = data.filter(
				(item) => item.name.toLowerCase().includes(search.toLowerCase()) // Filtrar por nombre de marca
			);
			setFilteredData(filtered);
		} else {
			setFilteredData(data); // Mostrar todos los datos si no hay búsqueda
		}
	}, [search, data]);

	return (
		<>
			<div className="functionality-container">
				<div>
					<h2 style={{ color: 'var(--theme-company)' }}>Marcas</h2>
				</div>

				<SearchCompany theme={'var(--theme-company)'} valor={search} setValor={(event)=>setSearch(event.target.value)} placeholder="Marcas"/>

				{/* Only show Add Brand button if user has permission */}
				{permisos?.editar ? (
					<div className="content-btn-add">
						<Button
							variant="contained"
							onClick={handleOpenModal}
							sx={{ fontWeight: "bold", letterSpacing: "1px", background: 'var(--theme-company)' }}>
							Nueva Marca
						</Button>
					</div>
				) : (<span></span>)}
			</div>

			<div className="datatable-container">
				{loading ? (
					<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
						<Box sx={{ textAlign: "center" }}>
							<CircularProgress />
							<Typography variant="body1" sx={{ mt: 2 }}>
								Cargando permisos...
							</Typography>
						</Box>
					</Box>
				) : (
					currentSize > 480 ? (
						<div className="table-view-pc">
							<Table columns={columns} data={filteredData} />
						</div>
					) : (
						<TablesMobile filteredData={(filteredData ?? []).map(obj => ({
							img: obj?.image,
							title: obj?.name,
							texto: obj?.created_at,
							fullPhone: null,
						}))} img={true} />
					)
				)}
			</div>

			{/* Only render the modal if user has permission to add brands */}
			{permisos?.editar && (
				<ModalNuevaMarca
					isOpen={isModalOpen && permisos?.editar}
					onClose={handleCloseModal}
					onBrandAdded={reloadBrands} // Callback para actualizar la lista
					selectedSucursal={selectedSucursal}
				/>
			)}
		</>
	);
};
